import { Subcampaign } from 'types';

import type {
  SubcampaignOffer,
  SubcampaignOfferUpdatePath,
  SubcampaignOfferUpdatePathType
} from 'types';

type Offer = SubcampaignOffer | undefined | null;

export const OFFER_MONETARY_CHANGE = 'monetary_change';
export const OFFER_MONETARY_TO_OTHER_CHANGE = 'monetary_to_other_change';
export const OFFER_OTHER_TO_MONETARY_CHANGE = 'other_to_monetary_change';
export const OFFER_OTHER_TO_OTHER_CHANGE = 'other_to_other_change';
const OFFER_TYPE_OTHER = 'other';
const OFFER_TYPE_OFFER = 'offer';

const getOfferSuffix = (
  offer: Offer
): SubcampaignOfferUpdatePathType => (
  offer?.type === OFFER_TYPE_OFFER ? 'budget' : 'other'
);

export const getOfferUpdatePath = (
  offer: Offer,
  updatedOffer: Offer
): SubcampaignOfferUpdatePath => {
  const offerType = getOfferSuffix(offer);
  const updatedOfferType = getOfferSuffix(updatedOffer);

  return {
    from: offerType,
    to: updatedOfferType
  };
};

export const getOfferRenegotiationMessageKey = (
  offer: Offer,
  updatedOffer: Offer
): string => {
  const updatePath = getOfferUpdatePath(offer, updatedOffer);
  const from = updatePath.from;
  const to = updatePath.to;
  let key = OFFER_MONETARY_CHANGE;

  if (from === 'budget' && to === OFFER_TYPE_OTHER) {
    key = OFFER_MONETARY_TO_OTHER_CHANGE;
  }

  if (from === OFFER_TYPE_OTHER && to === 'budget') {
    key = OFFER_OTHER_TO_MONETARY_CHANGE;
  }

  if (from === OFFER_TYPE_OTHER && to === OFFER_TYPE_OTHER) {
    key = OFFER_OTHER_TO_OTHER_CHANGE;
  }

  return key;
};

export function checkOfferType(subcampaign, offerType): boolean {
  return subcampaign && subcampaign.offer && subcampaign.offer.type === offerType || false;
}

export function isOffer(subcampaign?: Subcampaign | null): boolean {
  return checkOfferType(subcampaign, OFFER_TYPE_OFFER);
}
